export const NAV_LINKS = [
  { id: "metiers", label: "Pour qui" },
  { id: "realisations", label: "Réalisations" },
  { id: "offres", label: "Offres" },
  { id: "methode", label: "Méthode" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];
